import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import {DropdownModule, IconsModule, WavesModule, MdbSelectModule} from "ng-uikit-pro-standard";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    NavbarComponent
  ],
  exports: [
    NavbarComponent
  ],
    imports: [
        CommonModule,
        IconsModule,
        WavesModule,
        DropdownModule,
        RouterModule,
        MdbSelectModule,
        FormsModule
    ]
})
export class NavbarModule { }
